export default __webpack_public_path__ + "static/media/image-photon.02f662d7.jpg";